import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkDate'
})
export class CheckDatePipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    
    if(args[0] && args[0] == "toDB") {
      if (/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(value)) {
        const sp = value.split(".");
        return sp[2]+'-'+sp[1]+'-'+sp[0];
      } else if (/[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value))  {
        return value; 
      }
    } else {
      if(/^[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)) {
        return value;
      } else if (/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(value)) {
        const sp = value.split(".");
        return sp[2]+'-'+sp[1]+'-'+sp[0];
      }
    }
    return "";
  }

}
